import React, { FC } from "react";
import { useSearchParams } from "@Libs/Router/hooks/useSearchParams";
import { Portal } from "@UI/Components/Portal/Portal";
import { Icon } from "@UI/Components/Icon/Icon";

import messages from "./messages";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import { BrandPlus } from "@UI/Components/Icons/BrandPlus";
import { GenericAlert } from "@UI/Components/GenericAlert/GenericAlert";

export enum ServiceOfferConfirmationTypes {
  PAYMENT_METHOD_CONFIGURED = "payment_method_configured",
  SUBSCRIPTION_ACTIVATED = "subscription_activated",
}

export const ServiceOffersConfirmationMessagesRouter: FC = () => {
  const confirmation = useSearchParams("confirmation");

  const ConfirmationAlert = () => {
    switch (confirmation) {
      case ServiceOfferConfirmationTypes.PAYMENT_METHOD_CONFIGURED:
        return (
          <GenericAlert
            status="success"
            marginBottom="5"
            display="flex"
            justifyContent="center"
            data-testid="payment-method-configured-alert"
            textAlign="start"
          >
            <FormattedMessage
              {...messages.yourPaymentPreferencesHaveBeenSaved}
            />
          </GenericAlert>
        );
      case ServiceOfferConfirmationTypes.SUBSCRIPTION_ACTIVATED:
        return (
          <GenericAlert
            status="success"
            marginBottom="5"
            display="flex"
            justifyContent="center"
            data-testid="subscription-activated-alert"
            textAlign="start"
          >
            <FormattedMessage
              {...messages.congratsYourSubscriptionHasBeenActivated}
              values={{
                plus: () => (
                  <Icon as={BrandPlus} boxSize="3" mx="1" display="inline" />
                ),
              }}
            />
          </GenericAlert>
        );
      default:
        return null;
    }
  };

  return (
    <Portal id="confirmation-header">
      <ConfirmationAlert />
    </Portal>
  );
};
